<template>
  <div class="justify-content-center p-3"  :style="'background:' + (this.background === undefined ? '#59ABE3': this.background)">
    <div class="text-center" style="color: #FFFFFF; font-size: 1.4em; font-weight: 300">
      {{ seriesData.name }}
    </div>
    <div class="text-center" style="color: #FFFFFF; font-size: 1.4em; font-weight: 700; text-transform: uppercase">
      {{ currentCount | commas }} total attendees
    </div>
    <div class="d-flex justify-content-center" >
      <short-line :chart-data="chartData" :options="options" style="width: 90%; height: 100px" ></short-line>
    </div>
  </div>
</template>

<script>
import ShortLine from '../../utils/ShortLine'
export default {
  name: '',
  props: ['seriesData', 'background'],
  components: {ShortLine},
  computed: {
    chartData: function () {
      let labels = []
      let data = []
      this.seriesData.attendance.forEach((x) => {
        labels.push(x.name)
        data.push(x.value)
      })
      return {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderColor: '#ffffff'
          }
        ]

      }
    },
    currentCount: function () {
      let total = 0
      this.seriesData.attendance.forEach((x) => {
        total += x.value
      })
      return total
    }
  },
  data: function () {
    return {
      options: {
        aspectRatio: 1,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              display: false
            }
          }]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/events/EventsAttendanceChart.vue